import { PureComponent } from "react";

import { type IPortalType } from "utilities/portal/portal";

import { getDefaultLeftAlignment } from "commonComponents/entity/lineItem/LineItemPriceBreakdown/LineItemPriceBreakdown.utility";
import {
    type ITotalPriceDisplayProps,
    LineItemPriceBreakdownBase,
} from "commonComponents/entity/lineItem/LineItemPriceBreakdown/LineItemPriceBreakdownBase";
import { type LineItemPriceBreakdownInfo } from "commonComponents/entity/lineItem/LineItemPriceBreakdown/LineItemPriceBreakdownBase.types";
import { ShowOnPortal } from "commonComponents/utilities/ShowOnPortal/ShowOnPortal";

import { type TaxMethod } from "entity/tax/common/tax.types";
import { TaxRateBreakdownInfo } from "entity/tax/common/TaxRateBreakdown/TaxRateBreakdown.api.types";

interface IMarkupLineItemPriceBreakdownProps {
    canViewLineItems: boolean;
    isFlatFee: boolean;
    leftAlignContent?: boolean;
    maxTransactionAmount?: number;
    paymentLimitAmount?: number | null;
    priceBreakdown: LineItemPriceBreakdownInfo;
    priceTotalLabel?: string;
    renderCustomPriceDisplay?: (props: ITotalPriceDisplayProps) => React.ReactNode;
    showBreakdown?: boolean;
    showBreakdownButton?: boolean;
    showPriceOnly: boolean;
    taxMethod?: TaxMethod;
    useFormFieldLabel?: boolean;
    useUpdatedComponentWithTaxRates: boolean;
}

export class MarkupLineItemPriceBreakdown extends PureComponent<IMarkupLineItemPriceBreakdownProps> {
    static defaultProps = {
        priceTotalLabel: "Client Price",
        useFormFieldLabel: false,
        useUpdatedComponentWithTaxRates: false,
        taxRateBreakdownInfo: new TaxRateBreakdownInfo({
            taxRateBreakdownItems: [],
            totalTax: 0,
            taxOverride: 0,
        }),
        isFlatFee: false,
        canViewLineItems: true,
    };

    render() {
        const {
            canViewLineItems,
            isFlatFee,
            leftAlignContent,
            maxTransactionAmount,
            paymentLimitAmount,
            priceBreakdown,
            priceTotalLabel,
            showBreakdown,
            showBreakdownButton,
            showPriceOnly,
            useUpdatedComponentWithTaxRates,
            useFormFieldLabel,
        } = this.props;

        return (
            <ShowOnPortal
                builder
                subs
                owner
                render={(portalType: IPortalType) => {
                    const isBuilder = portalType.isBuilder;
                    return (
                        <LineItemPriceBreakdownBase
                            costLabelText="Builder cost"
                            isFlatFee={isFlatFee}
                            useFormFieldLabel={useFormFieldLabel}
                            useUpdatedComponentWithTaxRates={useUpdatedComponentWithTaxRates}
                            leftAlignContent={
                                leftAlignContent ??
                                getDefaultLeftAlignment(isBuilder, isFlatFee, canViewLineItems)
                            }
                            lineItemPriceBreakdownInfo={priceBreakdown}
                            linkPriceText="price"
                            maxTransactionAmount={maxTransactionAmount}
                            paymentLimitAmount={paymentLimitAmount ?? null}
                            renderCustomPriceDisplay={this.props.renderCustomPriceDisplay}
                            rightAlignPopover={isFlatFee || !canViewLineItems}
                            showBreakdown={showBreakdown ?? true}
                            showBreakdownButton={showBreakdownButton ?? true}
                            showBuilderCost={isBuilder}
                            showMargin={isBuilder}
                            showMarkup={isBuilder}
                            showPriceOnly={showPriceOnly}
                            totalPriceLabelText={priceTotalLabel!}
                        />
                    );
                }}
            />
        );
    }
}
